var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "referral_purchase-edit",
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { width: "70%" },
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "150px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "公司税号：", prop: "taxCode" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入公司税号" },
                model: {
                  value: _vm.form.taxCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "taxCode", $$v)
                  },
                  expression: "form.taxCode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商户号：", prop: "mcId" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入商户号" },
                model: {
                  value: _vm.form.mcId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "mcId", $$v)
                  },
                  expression: "form.mcId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "公司名称：", prop: "title" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入公司名称" },
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "企业地址：", prop: "enterpriseAddress" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入企业地址" },
                model: {
                  value: _vm.form.enterpriseAddress,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "enterpriseAddress", $$v)
                  },
                  expression: "form.enterpriseAddress",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "法人：", prop: "legalPersonName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入法人" },
                model: {
                  value: _vm.form.legalPersonName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "legalPersonName", $$v)
                  },
                  expression: "form.legalPersonName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "地区代码：", prop: "regionCode" } },
            [
              _c("el-input", {
                attrs: { type: "number", placeholder: "请输入地区代码" },
                model: {
                  value: _vm.form.regionCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "regionCode", $$v)
                  },
                  expression: "form.regionCode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "所在城市：", prop: "cityName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入所在城市" },
                model: {
                  value: _vm.form.cityName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "cityName", $$v)
                  },
                  expression: "form.cityName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "联系人名字：", prop: "contactsName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人名字" },
                model: {
                  value: _vm.form.contactsName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "contactsName", $$v)
                  },
                  expression: "form.contactsName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "联系人Email：", prop: "contactsEmail" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人Email" },
                model: {
                  value: _vm.form.contactsEmail,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "contactsEmail", $$v)
                  },
                  expression: "form.contactsEmail",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "联系人手机号：", prop: "contactsPhone" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人手机号" },
                model: {
                  value: _vm.form.contactsPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "contactsPhone", $$v)
                  },
                  expression: "form.contactsPhone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "销方电话：", prop: "sellerTel" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入销方电话" },
                model: {
                  value: _vm.form.sellerTel,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sellerTel", $$v)
                  },
                  expression: "form.sellerTel",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "销方开户行：", prop: "sellerBankName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入销方开户行" },
                model: {
                  value: _vm.form.sellerBankName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sellerBankName", $$v)
                  },
                  expression: "form.sellerBankName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "开户行账号：", prop: "sellerBankAccount" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入开户行账号" },
                model: {
                  value: _vm.form.sellerBankAccount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sellerBankAccount", $$v)
                  },
                  expression: "form.sellerBankAccount",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "营业执照：", prop: "businessLicense" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    action: "",
                    "auto-upload": false,
                    "show-file-list": false,
                    "on-change": _vm.handleBusinessLicenseChange,
                    "before-upload": _vm.beforeBusinessLicenseUpload,
                  },
                },
                [
                  _vm.businessLicenseUrl
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.getImageUrl(_vm.businessLicenseUrl) },
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon",
                      }),
                ]
              ),
              _vm._v(" "),
              _vm.businessLicenseUrl && !_vm.isEditMode
                ? _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _c("span", [
                      _vm._v(
                        "已选择文件：" + _vm._s(_vm.businessLicenseFileName)
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("\n        提交\n      ")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.resetForm } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }